(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState || Array(4).fill().map(function() {
            return Array(4).fill(0);
        });
        this.score = 0;
        this.status = "idle"; // 'idle', 'playing', 'win', 'lose'
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = Array(4).fill().map(function() {
                    return Array(4).fill(0);
                });
                this.score = 0;
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                var moved = false;
                this.board = this.board.map(function(row) {
                    var filtered = row.filter(function(v) {
                        return v !== 0;
                    });
                    for(var i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                        filtered[i] *= 2;
                        _this.score += filtered[i];
                        filtered[i + 1] = 0;
                        moved = true;
                    }
                    var newRow = filtered.filter(function(v) {
                        return v !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    if (!moved && row.toString() !== newRow.toString()) moved = true;
                    return newRow;
                });
                if (moved) this.addRandomTile();
                this.checkGameState();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.board = this.board.map(function(row) {
                    return row.reverse();
                });
                this.moveLeft();
                this.board = this.board.map(function(row) {
                    return row.reverse();
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.transpose();
                this.moveLeft();
                this.transpose();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.transpose();
                this.moveRight();
                this.transpose();
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                this.board.forEach(function(row, i) {
                    row.forEach(function(cell, j) {
                        if (cell === 0) emptyCells.push({
                            i: i,
                            j: j
                        });
                    });
                });
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], i = _emptyCells_Math_floor.i, j = _emptyCells_Math_floor.j;
                    this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "checkGameState",
            value: function checkGameState() {
                var _this = this;
                if (this.board.flat().includes(2048)) {
                    this.status = "win";
                    return;
                }
                var movesAvailable = this.board.some(function(row, i) {
                    return row.some(function(cell, j) {
                        return cell === 0 || j < 3 && cell === _this.board[i][j + 1] || i < 3 && cell === _this.board[i + 1][j];
                    });
                });
                if (!movesAvailable) this.status = "lose";
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var _this = this;
                this.board = this.board[0].map(function(_, i) {
                    return _this.board.map(function(row) {
                        return row[i];
                    });
                });
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$messages = {
    start: document.querySelector(".message-start"),
    win: document.querySelector(".message-win"),
    lose: document.querySelector(".message-lose")
};
function $197cd56b15c33885$var$updateUI() {
    var board = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$cells.forEach(function(cell, index) {
        var x = Math.floor(index / 4);
        var y = index % 4;
        var value = board[x][y];
        cell.className = "field-cell";
        if (value > 0) cell.classList.add("field-cell--".concat(value));
        cell.textContent = value || "";
    });
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    Object.keys($197cd56b15c33885$var$messages).forEach(function(key) {
        $197cd56b15c33885$var$messages[key].classList.add("hidden");
    });
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$messages.start.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messages.win.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messages.lose.classList.remove("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "playing" || $197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$startButton.textContent = "Restart";
    else $197cd56b15c33885$var$startButton.textContent = "Start";
    $197cd56b15c33885$var$startButton.classList.add("restart");
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$updateUI();
});
document.addEventListener("keydown", function(ev) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(ev.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$updateUI();
});

})();
//# sourceMappingURL=index.9fd7372a.js.map
